import { render, staticRenderFns } from "./advantage.vue?vue&type=template&id=e576f27c&scoped=true"
import script from "./advantage.vue?vue&type=script&lang=js"
export * from "./advantage.vue?vue&type=script&lang=js"
import style0 from "./advantage.vue?vue&type=style&index=0&id=e576f27c&prod&lang=css"
import style1 from "./advantage.vue?vue&type=style&index=1&id=e576f27c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e576f27c",
  null
  
)

export default component.exports